import { sectionTypes } from '@playbooks/core/src/constants'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

export default function lockVisibleHeaders(card: ActionCard, headers: number | null) {
  let headersIndex = 0
  card.sections.forEach(sec => {
    if (sec.type === sectionTypes.SEPARATOR) {
      if (!headers || headersIndex < headers) {
        sec.isLocked = true
      }
      headersIndex++
    }
  })
}
